import React, { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function MessageList({ messages, loading }) {
  const messagesEndRef = useRef(null);
  const listRef = useRef(null);

  useEffect(() => {
    // Auto-scroll to bottom when new message arrives
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [messages, loading]);

  const getInitials = (role) => {
    return role === 'user' ? 'You' : 'M';
  };

  if (messages.length === 0 && !loading) {
    return (
      <div className="message-list">
        <div className="message-container">
          <div className="empty-state">
            <h2>Welcome to Maestro</h2>
            <p>Ask about stations, markets, or campaign planning to get started.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="message-list" ref={listRef}>
      <div className="message-container">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.role}`}>
            <div className="message-header">
              <div className="message-avatar">{getInitials(msg.role)}</div>
              <span>{msg.role === 'user' ? 'You' : 'Maestro'}</span>
            </div>
            <div className="message-content-wrapper">
              <div className="message-content">
                {msg.role === 'assistant' ? (
                  <>
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {msg.content}
                    </ReactMarkdown>
                    {msg.pdf_blob_url && (
                      <div className="pdf-download-container">
                        <button
                          className="pdf-download-button"
                          onClick={() => {
                            const link = document.createElement('a');
                            link.href = msg.pdf_blob_url;
                            link.download = msg.pdf_filename || 'maestro-plan.pdf';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                          title="Download PDF"
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" y1="15" x2="12" y2="3"></line>
                          </svg>
                          <span>PDF</span>
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <div style={{ whiteSpace: 'pre-wrap' }}>{msg.content}</div>
                )}
              </div>
            </div>
          </div>
        ))}
        {loading && (
          <div className="message assistant">
            <div className="message-header">
              <div className="message-avatar">M</div>
              <span>Maestro</span>
            </div>
            <div className="message-content-wrapper">
              <div className="message-content">
                <div className="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
}

